module.exports = __webpack_public_path__ + "static/media/Lox_meat.298f17ca.png";